import { openDatesPopup } from '../../repositories/desktop-filters-micro-frontend/v1/openDatesPopup';
import { openAuthModal } from '../../repositories/header-frontend/v2/open-auth-modal/helpers';
import { setRegionId } from '../../repositories/header-frontend/v2/set-region-id/helpers';
import { disablePlaceholders } from '../../repositories/search-string-micro-frontend/v1/disablePlaceholders';
import { setView } from '../../repositories/search-string-micro-frontend/v1/setView';

import type { IMicrofrontendsAPI } from '../../../shared/common/services/microfrontends/types';

type TCreateMicrofrontendsAPIParams = {
  initHeaderApi: boolean;
};

export function createMicrofrontendsAPI({ initHeaderApi }: TCreateMicrofrontendsAPIParams): IMicrofrontendsAPI {
  return {
    header: initHeaderApi
      ? {
          setRegionId,
          openAuthModal,
        }
      : undefined,
    desktopFilters: {
      openDatesPopup,
    },
    searchString: {
      setView,
      disablePlaceholders,
    },
  };
}
